import { render, staticRenderFns } from "./BSButton.vue?vue&type=template&id=5495d2bf&"
import script from "./BSButton.vue?vue&type=script&lang=js&"
export * from "./BSButton.vue?vue&type=script&lang=js&"
import style0 from "./BSButton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports